// @ts-nocheck
import MainContainer from "../../layout/MainContainer";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Input,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { ChangeEvent, useEffect, useState } from "react";

import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
import { Loader, showError, showToast } from "../../constants";
import { UploadMedia, UploadVideo } from "../../utils/mediaUpload";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import { isString } from "../../utils/validations";
import {
  useLazyGetTutorialByIdQuery,
  usePostAddTutorialMutation,
  useUpdateTutorialMutation,
} from "../../services/tutorial";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import useTranslation from "../../hooks/Translation";
import {
  arabicInputProps,
  withArabicFieldClass,
} from "../../utils/arabicField";
import Progress from "../../components/ProgressBar";
import { CircularProgressbar } from "react-circular-progressbar";

const AddTutorial = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [addTutorial] = usePostAddTutorialMutation();
  const [updateTutorial] = useUpdateTutorialMutation();
  const [tutorialById] = useLazyGetTutorialByIdQuery();
  const [progress, setProgress] = useState("");
  console.log(progress, "progress");

  const [loading, setLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);
  const [thumbnail, setThumbnail] = useState<string>("");
  console.log(thumbnail, "thumbnail");
  const [tutorialData, setTutorialData] = useState<any>();
  const [value, setValue] = useState("sell");
  const [showVideo, setShowVideo] = useState(false);

  const [error, setError] = useState(false);
  const [video, setVideo] = useState<string | null>(null);
  const [image, setImage] = useState<string | undefined>("");
  const translate = useTranslation();

  const allowedTypes = [
    "video/mp4",
    "video/quicktime", // .mov
    "video/webm",
    "video/ogg",
    "video/x-msvideo", // .avi
    "video/x-matroska", // .mkv
    // Add more as needed
  ];

  // const convertDataUrltoImgUrl = async (base64Image: any) => {
  //   const byteCharacters = atob(base64Image.split(",")[1]);
  //   const byteNumbers = new Array(byteCharacters.length);
  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }
  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: "image/jpeg" });

  //   // Create an image URL from the Blob
  //   const imageUrl = URL.createObjectURL(blob);
  //   // Now, 'imageUrl' contains a regular image URL that you can use in your application
  //   const response = await UploadMedia(blob);
  //   if (response?.statusCode === 200) {
  //     // formik.setFieldValue("coverImg", response?.data);
  //     setThumbnail(response?.data);
  //   } else {
  //     showError(response?.message);
  //   }
  // };

  // const handleVideoUpload = async (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const file = event.target.files?.[0];

  //   if (file) {
  //     setLoading(true);
  //     // Create a video element
  //     const video = document.createElement("video");
  //     video.className = "upVideo";
  //     video.preload = "metadata";
  //     // Set the video source
  //     video.src = URL.createObjectURL(file);

  //     // Listen for the loadedmetadata event
  //     video.addEventListener("loadeddata", async () => {
  //       const duration = video.duration;
  //       console.log(duration, "sdfdsfdfsdf");

  //       // setVideoDuration(Math.ceil(duration));
  //       // Set the currentTime to a suitable position for capturing a thumbnail
  //       video.currentTime = Math.min(1, duration); // Capture thumbnail after 1 second

  //       // Wait for the seeked event
  //       video.addEventListener("seeked", async () => {
  //         // Create a canvas element
  //         const canvas = document.createElement("canvas");
  //         canvas.width = video.videoWidth;
  //         canvas.height = video.videoHeight;

  //         // Draw the current frame onto the canvas
  //         const context = canvas.getContext("2d");
  //         context?.drawImage(video, 0, 0, canvas.width, canvas.height);

  //         // Convert the canvas to a data URL representing the thumbnail
  //         const base64Image = canvas.toDataURL("image/jpeg");
  //         convertDataUrltoImgUrl(base64Image);

  //         if (file.type.startsWith("video/")) {
  //           const res = await UploadVideo(file);
  //           if (res?.statusCode === 200) {
  //             formik.setFieldValue("videoLink", res?.data);
  //             setLoading(false);
  //           } else {
  //             setLoading(false);
  //             showError("Invalid file format : only .mp4 files are allowed");
  //           }
  //         } else {
  //           // Display an error message for non-image files
  //           showError(translate?.error?.invalidVideo || "");
  //         }
  //         // Clean up: remove the video and canvas elements
  //         video.remove();
  //         canvas.remove();
  //       });
  //     });

  //     // Append the video element to the document (necessary for triggering events)
  //     document.body.appendChild(video);
  //   }
  // };

  const handleVideoUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (!file) {
      showError(translate?.error?.invalidVideo || "");
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      setVideoLoading(false);
      showError(translate?.error?.invalidVideoFormat || "");
      return;
    }

    try {
      setVideoLoading(true);

      let thumbnailBlob = null;
      try {
        thumbnailBlob = await captureVideoThumbnail(file);
      } catch (thumbError) {
        console.error("Failed to capture video thumbnail:", thumbError);
      }

      let thumbnailUploadResponse = null;
      if (thumbnailBlob) {
        try {
          thumbnailUploadResponse = await UploadMedia(thumbnailBlob);
        } catch (uploadError) {
          console.error("Failed to upload thumbnail:", uploadError);
        }
      }

      const videoUploadResponse = await UploadVideo(file);

      if (videoUploadResponse?.statusCode === 200) {
        setProgress("");
        formik.setFieldValue("videoLink", videoUploadResponse?.data);
        setThumbnail(thumbnailUploadResponse?.data || "");
        setVideoLoading(false);
      } else {
        setProgress("");
        setVideoLoading(false);
        showError(videoUploadResponse?.message || "Upload failed. Please try again.");
      }
    } catch (error: any) {
      setProgress("");
      setVideoLoading(false);
      showError(error?.message || "Something went wrong during video upload.");
      console.error(error, "Error uploading video");
    }

    // try {
    //   setLoading(true);

    //   // Capture thumbnail directly from file
    //   // const thumbnailDataUrl = await captureVideoThumbnail(file);

    //   // Convert thumbnail data URL to Blob
    //   // const thumbnailBlob = dataURLToBlob(thumbnailDataUrl);

    //   // Upload video and thumbnail
    //   const videoUploadResponse = await UploadVideo(file);
    //   // const thumbnailUploadResponse = await UploadMedia(thumbnailBlob);

    //   if (videoUploadResponse?.statusCode === 200) {
    //     formik.setFieldValue("videoLink", videoUploadResponse?.data);
    //     setThumbnail("");
    //   } else {
    //     showError("Upload failed. Please try again.");
    //   }
    // } catch (error) {
    //   console.error("Upload error:", error);
    //   showError("Something went wrong during upload");
    // } finally {
    //   setLoading(false);
    // }
  };

  function dataURLToBlob(dataUrl: string): Blob {
    const byteString = atob(dataUrl.split(",")[1]);
    const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  // const captureVideoThumbnail = (videoBlob: Blob): Promise<string> => {
  //   return new Promise((resolve, reject) => {
  //     const video = document.createElement("video");
  //     video.crossOrigin = "anonymous"; // Crucial for Safari canvas use
  //     video.muted = true;
  //     video.playsInline = true;
  //     video.preload = "auto";

  //     const objectUrl = URL.createObjectURL(videoBlob);
  //     video.src = objectUrl;

  //     const cleanUp = () => {
  //       URL.revokeObjectURL(objectUrl);
  //       video.remove();
  //     };

  //     const handleError = () => {
  //       cleanUp();
  //       reject("Failed to load video for thumbnail capture");
  //     };

  //     video.onerror = handleError;

  //     video.onloadedmetadata = () => {
  //       video.currentTime = 0.1; // Seek a bit into the video (not 0)
  //     };

  //     video.onseeked = () => {
  //       try {
  //         const canvas = document.createElement("canvas");
  //         canvas.width = video.videoWidth;
  //         canvas.height = video.videoHeight;

  //         const ctx = canvas.getContext("2d");
  //         if (!ctx) throw new Error("Could not get canvas context");

  //         ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  //         const dataUrl = canvas.toDataURL("image/jpeg");

  //         cleanUp();
  //         canvas.remove();
  //         resolve(dataUrl);
  //       } catch (err) {
  //         cleanUp();
  //         reject("Thumbnail capture failed");
  //       }
  //     };

  //     // Fallback: if seeked doesn’t fire in Safari, use timeout
  //     setTimeout(() => {
  //       if (video.readyState >= 2) {
  //         try {
  //           const canvas = document.createElement("canvas");
  //           canvas.width = video.videoWidth;
  //           canvas.height = video.videoHeight;
  //           const ctx = canvas.getContext("2d");
  //           if (ctx) {
  //             ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  //             const dataUrl = canvas.toDataURL("image/jpeg");
  //             cleanUp();
  //             canvas.remove();
  //             resolve(dataUrl);
  //             return;
  //           }
  //         } catch {
  //           // Ignore
  //         }
  //         cleanUp();
  //         reject("Fallback thumbnail capture failed");
  //       }
  //     }, 3000);
  //   });
  // };

  const captureVideoThumbnail = (file: File): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.src = URL.createObjectURL(file);
      video.muted = true;
      video.playsInline = true;
      video.crossOrigin = "anonymous";

      video.onloadedmetadata = () => {
        // Seek to 1 second or 0.5s if shorter
        const seekTo = Math.min(1, video.duration / 2);
        video.currentTime = seekTo;
      };

      video.onseeked = () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("Canvas context not available");

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject("Thumbnail generation failed");
          }
        }, "image/jpeg");
      };

      video.onerror = (e) => {
        reject("Error loading video for thumbnail capture");
      };
    });
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: tutorialData?.title || "",
      title_ar: tutorialData?.title_ar || "",
      description: tutorialData?.description || "",
      description_ar: tutorialData?.description_ar || "",
      videoLink: tutorialData?.video || "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required(translate?.error?.required || "")
        .max(80, translate?.error?.maxValidation || "")
        .min(3, translate?.error?.minValidation || ""),
      description: Yup.string()
        .required(translate?.error?.required || "")
        .max(200, translate?.error?.maxValidation200 || "")
        .min(3, translate?.error?.minValidation || ""),
      title_ar: Yup.string()
        .required(translate?.error?.required || "")
        .max(80, translate?.error?.maxValidation || "")
        .min(3, translate?.error?.minValidation || "")
        .test("no-spaces-only", translate?.error?.noSpacesOnly || "", (value) => {
          return value ? value.trim().length > 0 : true;
        }),
      description_ar: Yup.string()
        .required(translate?.error?.required || "")
        .max(200, translate?.error?.maxValidation200 || "")
        .min(3, translate?.error?.minValidation || "")
        .test("no-spaces-only", translate?.error?.noSpacesOnly || "", (value) => {
          return value ? value.trim().length > 0 : true;
        }),
      videoLink: Yup.string().required(translate?.error?.required || ""),
    }),
    onSubmit: async (values) => {
      if (!values?.videoLink) {
        setError(true);
        formik.setSubmitting(false);
        return;
      }

      formik.setSubmitting(true);

      const data = {
        title: formik.values.title,
        description: formik.values.description,
        title_ar: formik.values.title_ar,
        description_ar: formik.values.description_ar,
        video: values?.videoLink,
        thumbnail: thumbnail || tutorialData?.thumbnail || "",
      };
      console.log(data, "body for adding");

      if (id && id !== "add") {
        try {
          setLoading(true);
          let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
          const response = await updateTutorial({
            tutorialId: id,
            encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            setLoading(false);
            showToast(translate?.error?.tutorialUpdate || "");
            navigate("/manage-tutorials");
          } else {
            setLoading(false);
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.log(error);
        }
      } else {
        try {
          setLoading(true);
          let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
          const response = await addTutorial(encryptedBody).unwrap();
          if (response?.statusCode === 200) {
            setLoading(false);
            showToast(translate?.error?.tutorialAdd || "");
            formik.resetForm();
            navigate("/manage-tutorials");
          } else {
            setLoading(false);
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.log(error);
        }
      }
    },
  });

  const getTutorialDetail = async (tutorialId: string) => {
    try {
      setDetailLoading(true);
      const response = await tutorialById({ subId: tutorialId }).unwrap();
      if (response?.statusCode === 200) {
        setTutorialData(response?.data);
        setThumbnail(response?.data?.thumbnail || "");
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    } finally {
      setDetailLoading(false);
    }
  };

  useEffect(() => {
    if (id && id !== "add") {
      getTutorialDetail(id);
    }
  }, []);

  return (
    <div>
      <>
        {loading || detailLoading ? <Loader isLoad={loading || detailLoading} /> : null}
        {!loading && videoLoading && (
          <Progress isLoad={videoLoading} progress={progress} />
        )}
        <MainContainer>
          <div className="main_loyout">
            <div className="dashboard">
              {id && id !== "add" ? (
                <h1 className="mn_hdng">{translate?.main?.EditTutorial}</h1>
              ) : (
                <h1 className="mn_hdng">{translate?.main?.AddTutorial}</h1>
              )}
              <Button
                className="btn btn_primary"
                onClick={() => {
                  navigate("/manage-tutorials");
                }}
              >
                {translate?.main?.Back}
              </Button>
            </div>
            <Card className="cards">
              <form onSubmit={formik.handleSubmit}>
                <CardContent sx={{ p: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography className="custom_label">
                        {translate?.main?.UploadVideos}
                      </Typography>
                      {formik?.values?.videoLink ? (
                        <div className="upload_image_preview2">
                          <video
                            controls
                            width="100%"
                            height="100%"
                            poster={resolveMediaUrl(thumbnail)}
                          >
                            <source
                              src={resolveMediaUrl(formik?.values?.videoLink)}
                            />
                          </video>

                          <CancelIcon
                            onClick={() => {
                              formik.setFieldValue("videoLink", "");
                              setThumbnail("");
                            }}
                          />
                        </div>
                      ) : (
                        <Box className="upload_image_bnr">
                          <label htmlFor="icon-button-file-vdo">
                            <Input
                              sx={{ display: "none" }}
                              id="icon-button-file-vdo"
                              type="file"
                              inputProps={{
                                accept: "video/*",
                              }}
                              onChange={handleVideoUpload}
                            />
                            <Button
                              component="span"
                              className="upload_image_btn"
                            >
                              <AddIcon />
                            </Button>
                          </label>
                        </Box>
                      )}
                      {(error || formik.submitCount > 0) &&
                      !formik.values.videoLink ? (
                        <h6 className="err_msg">
                          {formik.errors.videoLink || translate?.error?.required}
                        </h6>
                      ) : (
                        ""
                      )}
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className="custom_label">
                          {" "}
                          {translate?.main?.Title} {translate?.main?.English}
                        </Typography>
                        <TextField
                          hiddenLabel
                          type="text"
                          name="title"
                          variant="outlined"
                          fullWidth
                          placeholder={translate?.tutorials?.titleEn || ""}
                          id="title"
                          className="text_field"
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else if (isString(val.target.value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.title}
                          helperText={
                            (formik.touched.title || formik.submitCount > 0) &&
                            formik.errors.title
                          }
                        />
                      </Grid>
                      <div style={{ marginTop: 20 }} />

                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className="custom_label">
                          {translate?.main?.Description}{" "}
                          {translate?.main?.English}
                        </Typography>
                        <TextField
                          className="text_field"
                          hiddenLabel
                          type="text"
                          placeholder={translate?.tutorials?.descEn || ""}
                          fullWidth
                          multiline
                          minRows={4}
                          maxRows={4}
                          name="description"
                          variant="outlined"
                          id="description"
                          inputProps={{ maxLength: 200 }}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else if (isString(val.target.value)) {
                              formik.handleChange(val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.description}
                          helperText={
                            (formik.touched.description ||
                              formik.submitCount > 0) &&
                            formik.errors.description
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className="custom_label">
                          {" "}
                          {translate?.main?.Title} {translate?.main?.Arabic}
                        </Typography>
                        <TextField
                          hiddenLabel
                          type="text"
                          name="title_ar"
                          variant="outlined"
                          fullWidth
                          placeholder={translate?.tutorials?.titleAr || ""}
                          id="title_ar"
                          className={withArabicFieldClass("text_field")}
                          inputProps={arabicInputProps}
                          onChange={(val) => {
                            const value = val.target.value;
                            if (value.trim().length === 0 && value.length > 0) {
                              return;
                            }
                            formik.handleChange(val);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.title_ar}
                          helperText={
                            (formik.touched.title_ar ||
                              formik.submitCount > 0) &&
                            formik.errors.title_ar
                          }
                        />
                      </Grid>
                      <div style={{ marginTop: 20 }} />

                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography className="custom_label">
                          {translate?.main?.Description}{" "}
                          {translate?.main?.Arabic}
                        </Typography>
                        <TextField
                          className={withArabicFieldClass("text_field")}
                          inputProps={{ maxLength: 200, ...arabicInputProps }}
                          hiddenLabel
                          type="text"
                          placeholder={translate?.tutorials?.descAr || ""}
                          fullWidth
                          multiline
                          minRows={4}
                          maxRows={4}
                          name="description_ar"
                          variant="outlined"
                          id="description_ar"
                          onChange={(val) => {
                            const value = val.target.value;
                            if (value.trim().length === 0 && value.length > 0) {
                              return;
                            }
                            formik.handleChange(val);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.description_ar}
                          helperText={
                            (formik.touched.description_ar ||
                              formik.submitCount > 0) &&
                            formik.errors.description_ar
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                      disabled={detailLoading || formik.isSubmitting}
                      onClick={() => setError(true)}
                    >
                      {translate?.main?.Save}
                    </Button>
                  </div>
                </CardContent>
              </form>
            </Card>
          </div>
        </MainContainer>
      </>
    </div>
  );
};

export default AddTutorial;
